// Mock data for Cheerings Plumbing Group

export const COMPANY = {
  name: "Cheerings Plumbing Group",
  phone: "0431 189 875",
  phoneLink: "+61431189875",
  email: "bookings@cheeringsplumbing.com.au",
  website: "https://cheeringsplumbing.com.au",
  area: "Sydney, NSW",
  hours: "24/7 – 365 Days a Year",
  rating: 4.9,
  reviewCount: 700,
  abn: "49 691 245 913",
  license: "NSW Lic. #349115C",
  instagram: "https://www.instagram.com/cheeringsplumbing",
  instagramHandle: "@cheeringsplumbing",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Areas", href: "#areas" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "blocked-drains",
    title: "Blocked Drains",
    short: "CCTV-assisted clearing, fast diagnosis, no-mess removal.",
    description:
      "Our blocked drain specialists use the latest CCTV drain cameras and high-pressure water jetting equipment to diagnose and clear any blockage — fast. From kitchen sinks and bathroom drains to sewer mainlines and stormwater pipes, we get water flowing again with no mess and a clear video report of the cause.",
    features: [
      "CCTV drain camera inspection",
      "High-pressure water jet clearing",
      "Tree root removal & cutting",
      "Sewer & stormwater mainline clearing",
      "Same-day service across Sydney",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/rr15y0yv_8d26fd21-3df5-4cdb-9cc8-61c157431b01.jpeg",
  },
  {
    id: "hot-water",
    title: "Hot Water Systems",
    short: "Repairs, replacements & installs — gas, electric & solar.",
    description:
      "No hot water? We service, repair and replace every type of hot water system across Sydney — gas, electric, heat pump and solar. Authorised dealers for Rinnai, Rheem, Bosch, Dux and Vulcan. Most repairs completed same-day with parts stocked on every van.",
    features: [
      "Same-day hot water repair",
      "Gas, electric, heat pump & solar systems",
      "Rinnai, Rheem, Bosch, Dux specialists",
      "New installations & upgrades",
      "Energy-efficient system advice",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/7tjh1mi4_1d9dcdf7-5604-413f-9ec4-e76655f26c63.jpeg",
  },
  {
    id: "gas-fitting",
    title: "Gas Fitting",
    short: "Licensed gas fitters for safe installs and repairs.",
    description:
      "Our fully certified NSW gas fitters handle every gas plumbing job — from new cooktop and oven connections to outdoor BBQ points, gas hot water and leak detection. All work is compliant with AS/NZS 5601 and comes with a Gas Compliance Certificate.",
    features: [
      "Cooktop & oven gas connections",
      "BBQ & outdoor gas points",
      "Gas leak detection & repair",
      "Gas hot water installation",
      "Compliance Certificates supplied",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/4y15gn48_IMG_5825.png",
  },
  {
    id: "toilet-tap-repairs",
    title: "Toilet & Tap Repairs",
    short: "Leaks, drips, running toilets — fixed first visit.",
    description:
      "Annoying drip? Constantly running toilet? Our team carries the most common tap cartridges, washers, cistern parts and seals on every van for first-visit fixes. We repair and replace all major brands of taps, mixers and toilets — saving you water and money.",
    features: [
      "Dripping & leaking tap repair",
      "Mixer tap replacement",
      "Running & leaking toilet repair",
      "Toilet & cistern replacement",
      "Water-saving fixture upgrades",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/xvbtiidv_IMG_5824.jpeg",
  },
  {
    id: "water-filters",
    title: "Water Filters",
    short: "Whole-home & under-sink filter installs and servicing.",
    description:
      "Enjoy crystal-clear, great-tasting water throughout your home. We supply and install under-sink filters, whole-home systems and reverse osmosis units tailored to Sydney's water supply. Scheduled cartridge replacement service available.",
    features: [
      "Under-sink filter installation",
      "Whole-home filtration systems",
      "Reverse osmosis units",
      "Cartridge replacement service",
      "Water testing & advice",
    ],
    image:
      "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHx3YXRlciUyMGhlYXRlcnxlbnwwfHx8fDE3Nzg5MTQ1NTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pipe-relining",
    title: "Pipe Relining",
    short: "No-dig pipe restoration with a 50-year guarantee.",
    description:
      "Skip the costly excavation. Our trenchless pipe relining technology restores broken or cracked drains and pipes from the inside out using a structural epoxy liner. Fast, mess-free and backed by a 50-year product guarantee.",
    features: [
      "No excavation required",
      "50-year product warranty",
      "Suitable for sewer & stormwater",
      "Tree root resistant once cured",
      "Faster & cheaper than pipe replacement",
    ],
    image: "/assets/pipe-relining.jpg",
  },
  {
    id: "leak-detection",
    title: "Leak Detection",
    short: "Acoustic & thermal leak detection — minimal disruption.",
    description:
      "Hidden leaks can damage your home and quietly drive up your water bill. We use acoustic listening equipment, thermal imaging and tracer gas to pinpoint hidden leaks under slabs, behind walls and in roof spaces — without unnecessary demolition.",
    features: [
      "Acoustic listening equipment",
      "Thermal imaging cameras",
      "Tracer gas detection",
      "Slab & wall leak location",
      "Insurance reports available",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_d2c2d26c-9bf0-4200-96a9-e976003bafd2/artifacts/1mz0ljre_IMG_5828.png",
  },
  {
    id: "emergency-plumbing",
    title: "Emergency Plumbing",
    short: "24/7 rapid response across all Sydney suburbs.",
    description:
      "Burst pipe, flooded bathroom, gas leak or sewage overflow? Don't wait. Our emergency response team operates 24 hours, 7 days a week across every Sydney suburb. Call 0431 189 875 anytime — we'll be on our way within the hour.",
    features: [
      "24/7 rapid response",
      "Burst pipe & flood repair",
      "Emergency gas leak response",
      "Sewage overflow clearing",
      "After-hours, weekends & public holidays",
    ],
    image:
      "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const AREAS = [
  "Eastern Suburbs",
  "Hills District",
  "Inner West",
  "North Shore",
  "Northern Beaches",
  "Northern Suburbs",
  "Central Coast",
  "South West Sydney",
  "Southern Sydney",
  "Western Sydney",
  "Sutherland Shire",
  "Sydney CBD",
];

export const REVIEWS = [
  {
    name: "Marcus M.",
    suburb: "Bondi",
    rating: 5,
    text: "Storm hit Saturday night and our shopfront downpipes were completely shot. Rang Cheerings on the Sunday, they were round Monday morning and replaced the lot in a day. Tidy job, no mess left behind. Sound blokes.",
    image: "/assets/reviews/exterior_downpipes.jpg",
    imageAlt: "Commercial downpipe replacement by Cheerings Plumbing Group",
  },
  {
    name: "David K.",
    suburb: "Parramatta",
    rating: 4.8,
    text: "Drain was blocked solid for two days, kitchen sink wouldn't budge. Called these guys in the morning and they were here within the hour. Cleared it fast and didn't try to upsell me extra work. Will definitely use again.",
  },
  {
    name: "Priya R.",
    suburb: "Chatswood",
    rating: 4.7,
    text: "We did a full warehouse fit-out and needed sprinkler runs, drainage and service pipework all done together. The Cheerings crew turned up on time every day and got it finished ahead of schedule. Couldn't fault them.",
    image: "/assets/reviews/industrial_sprinkler.jpg",
    imageAlt: "Industrial pipework and sprinkler installation by Cheerings Plumbing Group",
  },
  {
    name: "Jess L.",
    suburb: "Manly",
    rating: 4.9,
    text: "Got a new induction cooktop installed and the gas line redone. They were upfront about the price from the start, no hidden bits. Certified, quick, even cleaned up after themselves which doesn't always happen!",
  },
  {
    name: "Connor W.",
    suburb: "Sutherland",
    rating: 5,
    text: "Needed a compliant disabled toilet fitted at our warehouse before an audit. Cheerings did the lot — pan, grab rails, the works. Passed first inspection no worries. Saved us a heap of stress.",
    image: "/assets/reviews/accessible_toilet.jpg",
    imageAlt: "Disabled toilet installation in a warehouse by Cheerings Plumbing Group",
  },
];

export const TIME_SLOTS = [
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
];

export const STATS = [
  { value: "24/7", label: "Live Answering" },
  { value: "700+", label: "5-Star Reviews" },
  { value: "15+", label: "Years Experience" },
  { value: "100%", label: "Satisfaction Guaranteed" },
];

export const PROPERTY_TYPES = [
  {
    id: "residential",
    title: "Residential Plumbing",
    description:
      "Full-service plumbing for Sydney homes — apartments, townhouses, units and houses. Repairs, maintenance and upgrades by friendly licensed plumbers who treat your home with care.",
    features: [
      "General home repairs & maintenance",
      "Kitchen & bathroom plumbing",
      "Hot water & gas systems",
      "Blocked drains & leak repairs",
    ],
  },
  {
    id: "renovations",
    title: "Renovations",
    description:
      "Bathroom, kitchen and laundry renovation plumbing — from rough-in to final fit-off. We work alongside your builder, designer or DIY project to deliver compliant, high-quality plumbing.",
    features: [
      "Bathroom & ensuite renovations",
      "Kitchen rough-in & fit-off",
      "Laundry relocations",
      "Full plumbing redesign",
    ],
  },
  {
    id: "commercial",
    title: "Commercial Plumbing",
    description:
      "Offices, retail, cafés, restaurants, gyms and strata buildings — we keep your business running with prompt, scheduled and emergency commercial plumbing services.",
    features: [
      "Office & retail fit-outs",
      "Café & restaurant plumbing",
      "Scheduled maintenance contracts",
      "Strata & body corporate work",
    ],
  },
  {
    id: "industrial",
    title: "Industrial Plumbing",
    description:
      "Heavy-duty plumbing for factories, warehouses and industrial facilities across Sydney. Large-bore pipework, trade waste, backflow prevention and compliance certification.",
    features: [
      "Factory & warehouse pipework",
      "Trade waste systems",
      "Backflow prevention & testing",
      "Industrial gas fitting",
    ],
  },
  {
    id: "installations",
    title: "New Installations",
    description:
      "New-build and new-system installations — from a new hot water unit or dishwasher hook-up to complete plumbing rough-in for new homes and developments.",
    features: [
      "New home plumbing rough-in",
      "Hot water system installs",
      "Appliance connections",
      "New gas & water service lines",
    ],
  },
];
